import React from 'react';
import $ from 'jquery';
import Plotly from 'plotly.js/dist/plotly.min.js';
import {GetParams, MWBaseURL} from './../Utilities.js'
import {createApiClient} from "../api/ApiClient";

class GroupedGraph extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			firm: null,
			acct: null,
			sybl: null,

			group: null,
			agg: null,
			grpData: [],
			init: true,//Otherwise state change from null to the initial state passed will cause a table reload

			graphIsLoading: null
		};

		this.timeseries = []
		this.loading = false

		this.height = props.height

		this.graphLayout = {
			height: props.height,
			showlegend: false,
			xaxis: {
				rangemode: "tozero",
				type: 'category',
				fixedrange: true
			},
			yaxis: {
				title: "PNL",
				fixedrange: true,
				tickformat: '$,~s'
			},
			legend: {"orientation": "h"},
			margin: {
				t: 0,

				pad: 0
			}
		}

		this.graphConfig = {
			displaylogo: false,
			scrollZoom: false,
			responsive: true,
			displayModeBar: false
		}
		this.controller = new AbortController()
	}

	static getDerivedStateFromProps(props, state) {
		if(!state.init && (props.acct !== state.acct || props.firm !== state.firm || props.sybl !== state.sybl || props.group !== state.group || props.agg !== state.agg)){
			return {...props, needToUpdate: true}
		}
		return {...props, init: false};
	}

	componentDidUpdate(props, state){
		if(this.state.needToUpdate){
			this.setState({needToUpdate: false}, function(){
				this.loadGraph()
			})
		}
	}

	componentDidMount() {
		this.loadGraph()
	}

	componentWillUnmount(){
		this.setState({graphIsLoading: false})
		this.controller.abort();
	}

	loadGraph = () => {
		let self = this;

		this.controller.abort();
		this.controller = new AbortController()

		this.setState({graphIsLoading: true})

		const apiClient = createApiClient();
		apiClient.get(MWBaseURL()+'daily_grouped_series?'+GetParams(self.state), {signal: self.controller.signal})
		.then(data => {
			if($('#graph').length === 0){//this should be debugged as this error should never actually appear
				console.log("Graph does not exist this component should not exist")
				return;
			}

			self.timeseries = data

			self.setState({graphIsLoading: false})
			self.state.refilter({
				grpData: data
			})

			let graphLines = [{
				name: "P&L",
				hovertemplate: '%{y:$,.0f}',
				type: 'bar',
				y: data.map(x => x.pnl),
				x: data.map(x => x.agg),
				marker: {color: data.map(x => (x.pnl >= 0 ? '#228B22' : '#8B0000'))}
			}]

			Plotly.newPlot('graph', graphLines, self.graphLayout, this.graphConfig);

			document.getElementById("graph").on('plotly_click', function(data){
				if(data.points[0].x.length < 10 || self.timeseries.some((x) => x.agg === data.points[0].x && !x.missingExplorerData)){
					self.state.groupChange(null, data.points[0].x)
				}
			});
		}).catch(e => console.log(e.message));
	}


	render(){
		return (
			<div style={{height: this.height+"px", position: "relative"}}>
				{this.state.graphIsLoading && 
					(<div id="loading" className="p-4" style={{position: "absolute", width: "100%", zIndex: "20", background: "grey", opacity: "0.2", height: this.height+"px"}}>
						<div className="dotwrapper" style={{opacity: "1"}}>
							<div className="dot0" />
							<div className="dot1" />
							<div className="dot2" />
						</div>
					</div>)
				}
				<div id="graph"></div>
			</div>
		)
	}
}
export default GroupedGraph;